import { LegalPage, Section, ul } from "./LegalLayout";

export default function Privacy({ C, onBack }) {
  return (
    <LegalPage C={C} onBack={onBack} title="Aviso de Privacidad" updated="22 de julio de 2026">
      <Section C={C} title="1. Que datos recopilamos">
        Para prestarte el servicio, CuadraAI recopila la siguiente informacion:
        <ul style={ul(C)}>
          <li>Correo electronico y nombre, para identificar tu cuenta.</li>
          <li>Informacion financiera que registras tu mismo: ingresos, gastos y cuentas por cobrar.</li>
          <li>Datos de tus productos e inventario.</li>
          <li>Registros de tus ventas.</li>
          <li>Configuraciones de tu cuenta, como moneda y preferencias de la aplicacion.</li>
        </ul>
      </Section>

      <Section C={C} title="2. Como almacenamos tu informacion">
        Toda tu informacion se almacena de forma segura en Firebase, la infraestructura de Google Cloud.
        Aplicamos las practicas de seguridad de esta plataforma para proteger tus datos frente a accesos no autorizados.
      </Section>

      <Section C={C} title="3. Uso de tus datos">
        Tus datos se usan unicamente para prestarte el servicio: mostrar tu informacion financiera,
        gestionar tu inventario y permitir el funcionamiento de la inteligencia artificial dentro de tu cuenta.
        Nunca vendemos ni compartimos tu informacion con terceros con fines comerciales.
      </Section>

      <Section C={C} title="4. Tus derechos">
        Puedes solicitar en cualquier momento:
        <ul style={ul(C)}>
          <li>Eliminar tu cuenta y toda tu informacion asociada.</li>
          <li>Solicitar una copia de los datos almacenados.</li>
          <li>Corregir informacion incorrecta desde tu perfil.</li>
        </ul>
      </Section>

      <Section C={C} title="5. Eliminacion de cuenta">
        Puedes eliminar tu cuenta desde la seccion de Perfil dentro de la aplicacion, o escribiendonos
        directamente para solicitar la eliminacion de tus datos.
      </Section>

      <Section C={C} title="6. Contacto">
        Para dudas sobre privacidad, escribenos a soporte@cuadraai.com.
      </Section>
    </LegalPage>
  );
}
